import React from "react";
import { Heart } from "lucide-react";

/**
 * Renders a dog photo with optional CSS rotation. Falls back to a
 * branded placeholder card when no image_url is present.
 */
export default function DogImage({ dog, className = "", alt, priority = false }) {
  const rotation = Number(dog.image_rotation) || 0;
  const swap = rotation === 90 || rotation === 270;
  const scale = swap ? 1.4 : 1;
  const src = dog.image_url;

  if (!src) {
    return (
      <div
        className={`w-full h-full flex flex-col items-center justify-center ${className}`}
        style={{ backgroundColor: "#F7ECD9" }}
        data-testid="dog-image-placeholder"
      >
        <Heart size={40} color="#E27E4E" fill="#E27E4E" className="mb-3 opacity-90" />
        <div className="font-serif text-3xl" style={{ color: "#0E5C6E" }}>{dog.name}</div>
        <div className="text-[10px] uppercase tracking-[0.25em] mt-1" style={{ color: "#E27E4E" }}>Photo coming soon</div>
      </div>
    );
  }

  const style = rotation
    ? { transform: `rotate(${rotation}deg) scale(${scale})`, transformOrigin: "center" }
    : undefined;

  return (
    <img
      src={src}
      alt={alt || `${dog.name} — bulldog available for adoption`}
      style={style}
      loading={priority ? "eager" : "lazy"}
      decoding="async"
      className={`w-full h-full object-cover ${className}`}
    />
  );
}
